(() => {
  const start = () => {
    const roots = [...document.querySelectorAll('header-drawer > details, .ss-search-toggle')];
    const background = [...document.querySelectorAll('main, footer')];
    const previousInert = new Map(background.map(node => [node, node.inert]));
    const sync = () => {
      const opened = roots.some(root => root.open);
      document.body.classList.toggle('ss-navigation-open', opened);
      background.forEach(node => { node.inert = opened || previousInert.get(node); });
    };
    const close = root => {
      root.open = false;
      root.querySelectorAll('details[open]').forEach(node => {
        node.open = false;
        node.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
      root.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      sync();
      root.querySelector('summary')?.focus({preventScroll:true});
    };
    roots.forEach(root => {
      if (root.dataset.ssNavigationReady) return;
      root.dataset.ssNavigationReady = 'true';
      root.addEventListener('toggle', () => {
        root.querySelector('summary')?.setAttribute('aria-expanded', String(root.open));
        if (root.open) {
          roots.filter(other => other !== root && other.open).forEach(other => { other.open = false; });
          const target = root.querySelector('input[type=search], .menu-drawer__close-menu-btn');
          target?.focus({preventScroll:true});
        }
        sync();
      });
      root.querySelectorAll('details').forEach(node => node.addEventListener('toggle', () => {
        node.querySelector('summary')?.setAttribute('aria-expanded', String(node.open));
        if (node.open) node.querySelector('.menu-drawer__close-button')?.focus({preventScroll:true});
      }));
      root.addEventListener('click', event => {
        const trigger = event.target.closest('summary');
        if (trigger?.parentElement === root) {
          event.preventDefault(); event.stopPropagation();
          if (root.open) close(root);
          else { root.open = true; root.querySelector('input[type=search], .menu-drawer__close-menu-btn')?.focus({preventScroll:true}); }
          return;
        }
        if (trigger && root.contains(trigger)) {
          event.preventDefault(); event.stopPropagation();
          const level = trigger.parentElement;
          level.open = !level.open;
          trigger.setAttribute('aria-expanded',String(level.open));
          return;
        }
        if (event.target.closest('.menu-drawer__close-menu-btn, [data-ss-search-close], [data-ss-menu-close]')) {
          event.preventDefault(); event.stopPropagation(); close(root); return;
        }
        const back = event.target.closest('.menu-drawer__close-button');
        if (back) {
          event.preventDefault(); event.stopPropagation();
          const node = back.closest('details');
          node.querySelectorAll('details[open]').forEach(child => { child.open = false; });
          node.open = false;
          node.querySelector('summary')?.setAttribute('aria-expanded','false');
          node.querySelector('summary')?.focus({preventScroll:true});
        }
        if (root.closest('header-drawer') && event.target.closest('button')) event.stopPropagation();
      }, true);
      root.addEventListener('keydown', event => {
        if (!root.open) return;
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopImmediatePropagation();
          const nested = [...root.querySelectorAll('details[open]')].pop();
          if (nested) { nested.open = false; nested.querySelector('summary')?.focus(); }
          else close(root);
          return;
        }
        if (event.key !== 'Tab') return;
        const nested = [...root.querySelectorAll('details[open]')].pop();
        const scope = nested?.querySelector('.menu-drawer__submenu') || root.querySelector('.ss-search-panel, #menu-drawer');
        const nodes = [...scope.querySelectorAll('a[href], summary, button:not(:disabled), input:not(:disabled)')].filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && (document.activeElement === first || !scope.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !scope.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
      }, true);
      root.addEventListener('keyup', event => { if (event.key === 'Escape') event.stopImmediatePropagation(); }, true);
      root.addEventListener('focusout', event => { if (root.closest('header-drawer')) event.stopPropagation(); }, true);
    });
    window.addEventListener('pageshow', sync);
    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width:990px)').matches) roots.filter(root => root.closest('header-drawer') && root.open).forEach(close);
    }, {passive:true});
    sync();
  };
  if (document.readyState === 'loading') {
    const ready = () => { if (document.readyState === 'loading') return; document.removeEventListener('readystatechange', ready); start(); };
    document.addEventListener('readystatechange', ready);
  } else start();
})();
